
import { defineComponent, PropType } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'
import OkWpStatus from '@/modules/OktellModule/components/OkWpStatus/index.vue'

import { OktellClient } from '@/core/types/oktell.types'

export default defineComponent({
    components: {
        Loader,
        OkButton,
        OkWpStatus,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        client: {
            type: Object as PropType<OktellClient>,
            default: null,
        },
        haveWhatsapp: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reload', 'deal'],
    setup(props, { emit }) {
        const onReload = () => {
            emit('reload')
        }

        const onDeal = () => {
            emit('deal')
        }

        return {
            onReload,
            onDeal,
        }
    },
})
